import { createContext } from '@lit/context'
import { TSurfaceColor } from '@schmancy/types/surface'
export const SchmancySurfaceTypeContext = createContext<TSurfaceColor>('surface')
